import { useState } from "react";
import { UserMealListRow } from "./UserMealListRow";
import { UserMealListRowIngredients } from "./UserMealListRowIngredients";

export function UserMealList({ mealToDisplay, handleRemoveMeal, handleEdit }) {
  const [expandedMealId, setExpandedMealId] = useState(null);

  const toggleExpanded = (mealId) => {
    setExpandedMealId((prev) => (prev === mealId ? null : mealId));
  };

  return (
    <div className="max-w-3xl space-y-3">
      {mealToDisplay.map((meal) => (
        <div
          key={meal.mealId}
          className="bg-white border border-gray-200 rounded-2xl overflow-hidden"
        >
          <UserMealListRow
            meal={meal}
            handleRemoveMeal={handleRemoveMeal}
            handleEdit={handleEdit}
            isExpanded={expandedMealId === meal.mealId}
            onToggle={() => toggleExpanded(meal.mealId)}
          />
          {expandedMealId === meal.mealId && (
            <UserMealListRowIngredients ingredients={meal.ingredientList} />
          )}
        </div>
      ))}
    </div>
  );
}
